import { useState } from 'react'
import Button from 'observian-ui/lib/button'
import ContactModal from 'observian-ui/lib/modal/contact'
import { Link } from 'gatsby'
import { buildFormUrl } from '../../../utils/formRedirect'

import Cloud from 'components/SVG/cloud'
import ContactForm from 'components/Form/Contact'
import ObservianSecurity from 'components/SVG/observianSecurityManaged'
import Lock from 'components/SVG/lock'

import style from './managedSecurity.module.css'

const SecurityAssessment = () => {
  const [showModal, setShowModal] = useState(false)
  const [isSuccessful, setIsSuccessful] = useState(false)
  return (
    <section className={style.section} id="managedSecurity">
      <svg
        className={style.blueAngledLine}
        xmlns="http://www.w3.org/2000/svg"
        width="245"
        height="49"
        viewBox="0 0 245 49"
      >
        <defs>
          <linearGradient
            id="blue-angled-line-a"
            x1="12.453%"
            x2="87.895%"
            y1="51.357%"
            y2="48.692%"
          >
            <stop offset="0%" stopColor="#1D8DBA" />
            <stop offset="100%" stopColor="#03ECAE" />
          </linearGradient>
        </defs>
        <polygon
          fill="url(#blue-angled-line-a)"
          points="0 48.267 98.264 0 244.892 12.984 103.852 18.502"
        />
      </svg>
      <div className={style.top}>
        <svg
          viewBox="0 0 1456 258"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <polygon
            id="Path-130"
            fill="#FFF"
            points="6.15527344 -7.12386426e-15 0 257.259696 275.994141 173.018258 1059.8934 147.301788 1455.23145 -1.42108547e-14"
          />
        </svg>
      </div>
      <div className={style.contentContainer}>
        <div className={style.content}>
          <Lock className={style.lock} />
          <Cloud withLasers type="outline" className={style.cloud2} />
          <div className={style.left}>
            <header className={style.header}>
              <svg
                width="765px"
                height="57px"
                viewBox="0 0 765 57"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <linearGradient
                    x1="12.4534884%"
                    y1="50.1783256%"
                    x2="87.8953488%"
                    y2="49.8280769%"
                    id="linearGradimstitle1"
                  >
                    <stop stopColor="#1D8DBA" offset="0%" />
                    <stop stopColor="#03ECAE" offset="100%" />
                  </linearGradient>
                </defs>
                <g
                  id="Managed-Service"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g id="Group-32" transform="translate(1.000000, 1.000000)" fillRule="nonzero">
                    <path
                      d="M18.525,53.475 L18.525,28.2 L23.7,49.5 L40.5,49.5 L45.675,28.2 L45.675,53.475 L64.2,53.475 L64.2,0.975 L40.35,0.975 L32.1,30.825 L23.85,0.975 L0,0.975 L0,53.475 L18.525,53.475 Z M87.2250001,53.475 L89.5500001,45.45 L101.85,45.45 L104.175,53.475 L123.675,53.475 L105.525,0.975 L86.7750001,0.975 L68.6250001,53.475 L87.2250001,53.475 Z M98.6250001,32.1 L92.7000001,32.1 L95.7000001,21.3 L98.6250001,32.1 Z M146.925,53.475 L146.925,28.8 L158.325,53.475 L177.6,53.475 L177.6,0.975 L158.775,0.975 L158.775,25.65 L147.375,0.975 L128.1,0.975 L128.1,53.475 L146.925,53.475 Z M200.625,53.475 L202.95,45.45 L215.25,45.45 L217.575,53.475 L237.075,53.475 L218.925,0.975 L200.175,0.975 L182.025,53.475 L200.625,53.475 Z M212.025,32.1 L206.1,32.1 L209.1,21.3 L212.025,32.1 Z M264.525,54.45 C277.95,54.45 285.45,49.8 290.025,45.825 L290.025,22.5 L267.075,22.5 L267.075,35.175 L273,35.175 L273,37.2 C272.025,37.8 269.925,38.625 266.55,38.625 C260.1,38.625 255.975,33.975 255.975,27.15 C255.975,20.625 260.475,16.125 266.475,16.125 C270.675,16.125 273.6,17.7 276.15,19.95 L286.725,8.55 C282.45,4.125 275.625,0 264.375,0 C247.425,0 236.1,12.075 236.1,27.15 C236.1,42.675 246.9,54.45 264.525,54.45 Z M328.35,53.475 L328.35,38.7 L314.55,38.7 L314.55,33.975 L326.85,33.975 L326.85,20.1 L314.55,20.1 L314.55,15.75 L328.35,15.75 L328.35,0.975 L295.575,0.975 L295.575,53.475 L328.35,53.475 Z M353.4,53.475 C371.025,53.475 382.725,43.35 382.725,27.15 C382.725,10.725 370.875,0.975 353.4,0.975 L334.65,0.975 L334.65,53.475 L353.4,53.475 Z M354.225,38.475 L353.1,38.475 L353.1,15.975 L354.225,15.975 C359.7,15.975 363.3,19.5 363.3,27.15 C363.3,34.8 359.7,38.475 354.225,38.475 Z M423.000001,54.45 C435.525001,54.45 443.475001,47.85 443.475001,37.5 C443.475001,22.725 422.925001,21.525 422.925001,16.575 C422.925001,15.825 423.525001,15.225 424.500001,15.225 C426.900001,15.225 429.150001,17.7 430.275001,20.025 L443.625001,12.375 C442.200001,7.875 435.525001,0 423.525001,0 C411.750001,0 403.800001,6.6 403.800001,16.725 C403.800001,32.25 424.275001,32.925 424.275001,37.725 C424.275001,38.475 423.750001,39 422.775001,39 C420.450001,39 417.750001,36.75 415.800001,33.45 L402.225001,40.8 C404.175001,46.2 410.475001,54.45 423.000001,54.45 Z M481.500001,53.475 L481.500001,38.7 L467.700001,38.7 L467.700001,33.975 L480.000001,33.975 L480.000001,20.1 L467.700001,20.1 L467.700001,15.75 L481.500001,15.75 L481.500001,0.975 L448.725001,0.975 L448.725001,53.475 L481.500001,53.475 Z M514.425001,54.45 C522.675001,54.45 528.000001,52.35 532.350001,49.275 L526.725001,34.2 C524.325001,36.375 520.875001,38.325 516.525001,38.325 C510.675001,38.325 506.025001,33.975 506.025001,27.15 C506.025001,20.625 510.525001,16.125 516.525001,16.125 C520.575001,16.125 523.800001,17.7 526.350001,20.175 L532.050001,5.175 C527.850001,2.25 522.375001,0 514.425001,0 C497.325001,0 486.150001,12.075 486.150001,27.15 C486.150001,43.5 498.000001,54.45 514.425001,54.45 Z M561.825001,54.45 C577.575001,54.45 586.125001,45.525 586.125001,32.85 L586.125001,0.975 L567.075001,0.975 L567.075001,33.3 C567.075001,36.9 564.975001,38.775 561.825001,38.775 C558.750001,38.775 556.725001,36.9 556.725001,33.3 L556.725001,0.975 L537.675001,0.975 L537.675001,32.85 C537.675001,45.525 546.150001,54.45 561.825001,54.45 Z M610.875001,53.475 L610.875001,36.525 L618.300001,53.475 L638.925001,53.475 L626.925001,31.5 C631.350001,29.025 635.250001,24.075 635.250001,18 C635.250001,8.475 628.050001,0.975 615.750001,0.975 L592.425001,0.975 L592.425001,53.475 L610.875001,53.475 Z M613.125001,22.575 L610.875001,22.575 L610.875001,15.225 L613.125001,15.225 C615.525001,15.225 616.875001,17.1 616.875001,18.9 C616.875001,20.7 615.525001,22.575 613.125001,22.575 Z M660.675001,53.475 L660.675001,0.975 L641.625001,0.975 L641.625001,53.475 L660.675001,53.475 Z M695.175001,53.475 L695.175001,15.75 L705.525001,15.75 L705.525001,0.975 L665.850001,0.975 L665.850001,15.75 L676.125001,15.75 L676.125001,53.475 L695.175001,53.475 Z M745.575001,53.475 L745.575001,31.05 L762.000001,0.975 L741.675001,0.975 L736.425001,15.9 L731.175001,0.975 L710.100001,0.975 L726.525001,31.05 L726.525001,53.475 L745.575001,53.475 Z"
                      id="MANAGEDSECURITY"
                      stroke="url(#linearGradimstitle1)"
                      strokeWidth="2"
                    />
                    <path
                      d="M18.525,53.475 L18.525,28.2 L23.7,49.5 L40.5,49.5 L45.675,28.2 L45.675,53.475 L64.2,53.475 L64.2,0.975 L40.35,0.975 L32.1,30.825 L23.85,0.975 L0,0.975 L0,53.475 L18.525,53.475 Z M87.2250001,53.475 L89.5500001,45.45 L101.85,45.45 L104.175,53.475 L123.675,53.475 L105.525,0.975 L86.7750001,0.975 L68.6250001,53.475 L87.2250001,53.475 Z M98.6250001,32.1 L92.7000001,32.1 L95.7000001,21.3 L98.6250001,32.1 Z M146.925,53.475 L146.925,28.8 L158.325,53.475 L177.6,53.475 L177.6,0.975 L158.775,0.975 L158.775,25.65 L147.375,0.975 L128.1,0.975 L128.1,53.475 L146.925,53.475 Z M200.625,53.475 L202.95,45.45 L215.25,45.45 L217.575,53.475 L237.075,53.475 L218.925,0.975 L200.175,0.975 L182.025,53.475 L200.625,53.475 Z M212.025,32.1 L206.1,32.1 L209.1,21.3 L212.025,32.1 Z M264.525,54.45 C277.95,54.45 285.45,49.8 290.025,45.825 L290.025,22.5 L267.075,22.5 L267.075,35.175 L273,35.175 L273,37.2 C272.025,37.8 269.925,38.625 266.55,38.625 C260.1,38.625 255.975,33.975 255.975,27.15 C255.975,20.625 260.475,16.125 266.475,16.125 C270.675,16.125 273.6,17.7 276.15,19.95 L286.725,8.55 C282.45,4.125 275.625,0 264.375,0 C247.425,0 236.1,12.075 236.1,27.15 C236.1,42.675 246.9,54.45 264.525,54.45 Z M328.35,53.475 L328.35,38.7 L314.55,38.7 L314.55,33.975 L326.85,33.975 L326.85,20.1 L314.55,20.1 L314.55,15.75 L328.35,15.75 L328.35,0.975 L295.575,0.975 L295.575,53.475 L328.35,53.475 Z M353.4,53.475 C371.025,53.475 382.725,43.35 382.725,27.15 C382.725,10.725 370.875,0.975 353.4,0.975 L334.65,0.975 L334.65,53.475 L353.4,53.475 Z M354.225,38.475 L353.1,38.475 L353.1,15.975 L354.225,15.975 C359.7,15.975 363.3,19.5 363.3,27.15 C363.3,34.8 359.7,38.475 354.225,38.475 Z M423.000001,54.45 C435.525001,54.45 443.475001,47.85 443.475001,37.5 C443.475001,22.725 422.925001,21.525 422.925001,16.575 C422.925001,15.825 423.525001,15.225 424.500001,15.225 C426.900001,15.225 429.150001,17.7 430.275001,20.025 L443.625001,12.375 C442.200001,7.875 435.525001,0 423.525001,0 C411.750001,0 403.800001,6.6 403.800001,16.725 C403.800001,32.25 424.275001,32.925 424.275001,37.725 C424.275001,38.475 423.750001,39 422.775001,39 C420.450001,39 417.750001,36.75 415.800001,33.45 L402.225001,40.8 C404.175001,46.2 410.475001,54.45 423.000001,54.45 Z M481.500001,53.475 L481.500001,38.7 L467.700001,38.7 L467.700001,33.975 L480.000001,33.975 L480.000001,20.1 L467.700001,20.1 L467.700001,15.75 L481.500001,15.75 L481.500001,0.975 L448.725001,0.975 L448.725001,53.475 L481.500001,53.475 Z M514.425001,54.45 C522.675001,54.45 528.000001,52.35 532.350001,49.275 L526.725001,34.2 C524.325001,36.375 520.875001,38.325 516.525001,38.325 C510.675001,38.325 506.025001,33.975 506.025001,27.15 C506.025001,20.625 510.525001,16.125 516.525001,16.125 C520.575001,16.125 523.800001,17.7 526.350001,20.175 L532.050001,5.175 C527.850001,2.25 522.375001,0 514.425001,0 C497.325001,0 486.150001,12.075 486.150001,27.15 C486.150001,43.5 498.000001,54.45 514.425001,54.45 Z M561.825001,54.45 C577.575001,54.45 586.125001,45.525 586.125001,32.85 L586.125001,0.975 L567.075001,0.975 L567.075001,33.3 C567.075001,36.9 564.975001,38.775 561.825001,38.775 C558.750001,38.775 556.725001,36.9 556.725001,33.3 L556.725001,0.975 L537.675001,0.975 L537.675001,32.85 C537.675001,45.525 546.150001,54.45 561.825001,54.45 Z M610.875001,53.475 L610.875001,36.525 L618.300001,53.475 L638.925001,53.475 L626.925001,31.5 C631.350001,29.025 635.250001,24.075 635.250001,18 C635.250001,8.475 628.050001,0.975 615.750001,0.975 L592.425001,0.975 L592.425001,53.475 L610.875001,53.475 Z M613.125001,22.575 L610.875001,22.575 L610.875001,15.225 L613.125001,15.225 C615.525001,15.225 616.875001,17.1 616.875001,18.9 C616.875001,20.7 615.525001,22.575 613.125001,22.575 Z M660.675001,53.475 L660.675001,0.975 L641.625001,0.975 L641.625001,53.475 L660.675001,53.475 Z M695.175001,53.475 L695.175001,15.75 L705.525001,15.75 L705.525001,0.975 L665.850001,0.975 L665.850001,15.75 L676.125001,15.75 L676.125001,53.475 L695.175001,53.475 Z M745.575001,53.475 L745.575001,31.05 L762.000001,0.975 L741.675001,0.975 L736.425001,15.9 L731.175001,0.975 L710.100001,0.975 L726.525001,31.05 L726.525001,53.475 L745.575001,53.475 Z"
                      id="MANAGEDSECURITY-Copy"
                      fill="url(#linearGradimstitle1)"
                      opacity="0.723958333"
                    />
                  </g>
                </g>
              </svg>
              <p>
                Protect your data, network, and applications with the help from our security experts
                and through our network of security software partners. Observian can help you gain a
                clear understanding of your overall Security Posture and see how you stack up
                against <b>NIST, HIPAA, GDPR Readiness, SOC2, ISO 27001, PCI-DSS</b> compliance.
                <br />
                <br />
                Observian is closely partnered with industry leaders like Datadog, Lacework, and
                Fortinet. Our managed service offering removes the Complexity & Cost of Cloud
                Security & Compliance.
                <br />
                <br />
                Observian lifts the burden of monitoring, alerting, investigation analysis, and
                reporting off your shoulders. Observian’s managed service teams fuse years of cloud
                experience at some of the biggest names in tech to optimize, secure and observe your
                cloud environment and let your company get back to doing what it does best!
                <br />
              </p>
              <Button
                label="Get a Quote for Managed Security"
                outline
                onClick={() => window.location.href = buildFormUrl([
                  {
                    key: 'CTA',
                    value: 'Google Cloud - Managed Service - Get a Quote for Managed Security'
                  }
                ])}
              />
              <span>
                <h3>Learn more about Managed Security with Tooling</h3>
                <div className={style.linkList}>
                  <Link className={style.links} to="/datadog">
                    <Button label="Datadog" />
                  </Link>
                  <Link className={style.links} to="/aws/managed-security">
                    <Button label="Lacework" />
                  </Link>
                  <Link className={style.links} to="/aws/managed-security-fortinet">
                    <Button label="Fortinet" />
                  </Link>
                </div>
                <div>
                  <a
                    href="https://aws.amazon.com/marketplace/seller-profile?id=6493516d-3d9b-4be8-ad25-9c61844f7d13"
                    className={style.links}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <br />
                    <br />
                    <Button label="AWS Marketplace Listings" variant="secondary" />
                  </a>
                </div>
              </span>
            </header>
          </div>
          <div className={style.right}>
            <ObservianSecurity className={style.security} />
          </div>
        </div>
        <svg
          viewBox="0 0 1444 375"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          className={style.bottomDiv}
        >
          <defs>
            <linearGradient
              x1="12.4534884%"
              y1="51.3405347%"
              x2="87.8953488%"
              y2="48.7075949%"
              id="linearGradbottGrad1"
            >
              <stop stopColor="#1D8DBA" offset="0%" />
              <stop stopColor="#03ECAE" offset="100%" />
            </linearGradient>
            <filter
              x="-12.2%"
              y="-62.5%"
              width="124.5%"
              height="225.0%"
              filterUnits="objectBoundingBox"
              id="filtebotfi2"
            >
              <feGaussianBlur stdDeviation="10" in="SourceGraphic" />
            </filter>
          </defs>
          <g id="Managed-Service" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <polygon
              id="Path-131"
              fill="#FFFFFF"
              points="0.736816406 0 0.736816406 341.64574 1443.45425 374.726562 1437.23145 325.319833 736.73505 84.9818851 312.624023 70.7265625"
            />
            <polygon
              id="Path-4-Copy"
              fill="url(#linearGradbottGrad1)"
              filter="url(#filtebotfi2)"
              transform="translate(297.731445, 70.726562) rotate(-10.000000) translate(-297.731445, -70.726562) "
              points="175.231445 94.7265625 273.538171 46.7265625 420.231445 59.6390359 279.128609 65.1263634"
            />
            <polygon
              id="Path-4"
              fill="url(#linearGradbottGrad1)"
              points="175.231445 94.7265625 273.538171 46.7265625 420.231445 59.6390359 279.128609 65.1263634"
            />
          </g>
        </svg>
      </div>
      {showModal ? (
        <ContactModal
          showClose
          shouldCloseOnOverlayClick
          onClose={() => setShowModal(false)}
          onDismiss={() => setShowModal(false)}
          isOpen={showModal}
          closeButtonPosition="right"
          ariaHideApp={false}
          success={isSuccessful}
        >
          <ContactForm
            showLogo
            headerTitle="Contact Us"
            buttonLabel="Send"
            ctaIntentSuffix="modal-managed-security"
            inquiryPlaceholder="We want to take our security to the next level with your managed security service."
            isSuccessfulCallback={(v) => {
              setIsSuccessful(v)
              if (!v) {
                setShowModal(false)
              }
            }}
          />
        </ContactModal>
      ) : null}
    </section>
  )
}

export default SecurityAssessment
